<app-header></app-header>
<div [ngClass]="windowWidth > 900 ? 'menu_icon_adjustment' : ''" (window:resize)="onResize($event)">
  <div class="app_content" id="app_content">
    <router-outlet></router-outlet>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 1)"
  template="<img class='spinner_icon' src='assets/icons/spinner.gif' />"
>
</ngx-spinner>